import {HttpClient, HttpErrorResponse, HttpHeaders, HttpParams} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import {
    AuthenticationService,
    AuthorizationConfig,
    AuthorizationConfigToken,
    IAuthenticationManager, IAuthenticationServiceToken,
    OpenIDConnectUser, PreviousRouteService,
    ToastService,
    User,
    UserService,
    UserWithAuthorizations
} from '@cnj/uikit';
import {Router} from '@angular/router';
import {SisnorAuthService} from "./service/sisnor-auth-service";
import {environment} from "../app/environment";
import {SisnorUser} from "../app/models/sisno-user";
import {map} from "rxjs/operators";
import {TjmgResponseBase} from "../app/response-tjmg/tjmg-response-base";
import {IProviderAuthenticationService} from "@cnj/uikit/lib/shared/auth/authentication/abstraction/provider-authentication.service";

export interface Permission {
    resource: string;
    action: string;
}

// Classe responsável por buscar as roles do usuário
// e atribuir informações de regra de negócio, no caso, comarca

@Injectable({
    providedIn: 'root'
})
export class SisnorAuthenticationManager implements IAuthenticationManager<OpenIDConnectUser, SisnorUser> {

    constructor(
        protected httpClient: HttpClient,
        @Inject(AuthorizationConfigToken)
        protected authorizationConfig: AuthorizationConfig,
        protected sisnorService: SisnorAuthService,
        private previousRouteService: PreviousRouteService,
        protected userService: UserService,
        protected router: Router,
        protected toastService: ToastService,
        @Inject(IAuthenticationServiceToken) @Optional() private providerAuthenticationService?: IProviderAuthenticationService<User>,

    ) {
        this.sisnorService.carregarPermissoes();
    }

    transform(user: OpenIDConnectUser): Promise<SisnorUser> {

        this.httpClient
            .get<any>(
                `${environment.settings.api.url}/verifica-usuario-login`,
                {headers: new HttpHeaders()
                        .set('Authorization', `Bearer ${user.access_token}`)}).subscribe((resposta: TjmgResponseBase) => {
            if(resposta.code === '200') {
                const paginaAnterior = this.previousRouteService.getPreviousUrl();
                this.login({enderecoParaVoltar: paginaAnterior});
                return;
            }

        });

        return new Promise<SisnorUser>((resolve) => {

            let finalUser = user as UserWithAuthorizations & OpenIDConnectUser & SisnorUser;

            const accessTokenPayload1 = JSON.parse(atob(finalUser.access_token.split('.')[1]));

            const usuarioFinal1 = Object.assign(user, accessTokenPayload1) as OpenIDConnectUser;
            usuarioFinal1.access_token = finalUser.access_token;
            (usuarioFinal1 as any).access_token = finalUser.access_token;

            let userToReturn = JSON.parse(JSON.stringify(user)) as OpenIDConnectUser &
                SisnorUser & { authorization: { permissions: Array<{ scopes: Array<string>, rsid: string, rsname: string }> } };

            userToReturn.roles = [];
            userToReturn.authorizations = this.retornarAuthorizations(userToReturn);
            userToReturn.roles = this.retornarRoles(userToReturn);
            //console.log('userToReturn.roles =>', userToReturn.roles);
            resolve(userToReturn);
        }).catch(error => {
            this.showError(error.message ? error.message : '');
            this.router.navigate(['not-found']);
            return error;
        });

    }

    login(args?: { param?: any ,enderecoParaVoltar?: string }): Promise<void> {
        const isOnline = navigator.onLine;
        if (isOnline) {

            if (args && args.enderecoParaVoltar) {
                localStorage.setItem('authentication-callback', args.enderecoParaVoltar);
            }

            const lastUri = localStorage.getItem('authentication-callback');
            if (!lastUri) {
                localStorage.setItem('authentication-callback', window.location.href);
            }
            const param = args && args.param;
            return this.providerAuthenticationService.login(param);
        } else {
            throw new Error('Não é possível se autenticar sem conexão de rede!');
        }
    }

    retornaUsuario(user: any) {
        let finalUser = user as UserWithAuthorizations & OpenIDConnectUser & SisnorUser;

        const accessTokenPayload1 = JSON.parse(atob(finalUser.access_token.split('.')[1]));

        const usuarioFinal1 = Object.assign(user, accessTokenPayload1) as OpenIDConnectUser;
        usuarioFinal1.access_token = finalUser.access_token;
        (usuarioFinal1 as any).access_token = finalUser.access_token;

        let userToReturn = JSON.parse(JSON.stringify(user)) as OpenIDConnectUser &
            SisnorUser & { authorization: { permissions: Array<{ scopes: Array<string>, rsid: string, rsname: string }> } };

        userToReturn.roles = [];
        userToReturn.authorizations = this.retornarAuthorizations(userToReturn);
        userToReturn.roles = this.retornarRoles(userToReturn);
        return userToReturn;
    }

    retornarRoles(usur) {
        return usur.resource_access && usur.resource_access[environment.settings.authentication.client_id]
        && usur.resource_access[environment.settings.authentication.client_id].roles ?
            this.sisnorService.obterRoles(usur.resource_access[environment.settings.authentication.client_id].roles)
            : [];
    }

    validarResponse(code: any) {
        switch(code) {
            case "200": {
                console.info("Sucesso");
                break;
            }
            default: {
                throw new HttpErrorResponse({
                    status: code,
                    statusText: "Erros de Response"
                })
            }
        }
    }

    private retornarAuthorizations(userToReturn: User & { access_token: string; client_id: string; }
        & { id_token: string; } & SisnorUser & { authorization: { permissions: { scopes: string[];
                rsid: string; rsname: string; }[]; }; }): { action: string[]; resource: string; client?: string; }[] {
        userToReturn.authorizations = [];

        this.sisnorService.retornarAuthorizations(userToReturn).forEach(each => userToReturn.authorizations.push(each));

        return userToReturn.authorizations;
    }

    showError(erro) {
        this.toastService.clear();
        this.toastService.error(erro, null, `Erro`);
    }

}

